<template>
  <div style="margin-bottom: 0" v-if="category">
    <template v-if="editText">
      <div class="text-xs-center" v-if="isLoading" style="padding-top: 15px; padding-bottom: 15px">
        <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
      </div>
      <div
        v-else
        class="category-name form-control"
        :class="{ 'has-error': errors.has('categoryname') }"
        style="width: 100%"
      >
        <input
          v-validate="`excluded: ${categoryname}`"
          ref="category"
          type="text"
          name="categoryname"
          :data-vv-as="$t('Category name')"
          v-model="category.name"
          :placeholder="$t('Enter Category Name')"
        />
        <span class="text-error" v-if="errors.has('categoryname')">{{
          errors.first('categoryname')
        }}</span>

        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancelEditCategory">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="editCategory">{{ $t('Save') }}</v-btn>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="display: flex; align-items: stretch">
        <div class="move-vertical text-xs-center">
          <slot name="move"></slot>
        </div>
        <div class="category-name text-truncate form-control ignore-elements">
          <div>{{ category.name }}</div>
        </div>
        <div class="action text-xs-right ignore-elements">
          <v-btn
            fab
            outline
            color="primary"
            small
            class="extra-small ma-1"
            v-if="!editText"
            @click="onEditCategory"
          >
            <em class="fa fa-pencil-alt" aria-hidden="true" />
          </v-btn>
          <v-btn
            fab
            outline
            color="primary"
            small
            class="extra-small ma-1"
            @click="onDeleteCategory"
          >
            <em class="fa fa-trash" aria-hidden="true" />
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  props: ['value', 'categorylist'],
  data: function () {
    return {
      category: undefined,
      editText: false,
      isLoading: false
    }
  },
  mounted: function () {
    var vm = this

    vm.category = vm.value
    vm.cached_category = JSON.stringify(vm.value)
  },
  components: {
    PulseLoader
  },
  computed: {
    ...mapGetters(['selectedBot']),
    categoryname() {
      return this.categorylist.filter((v) => v.id !== this.value.id).map((v) => v.name)
    }
  },
  methods: {
    onDeleteCategory: function () {
      this.$emit('onDelete', this.category.id)
    },
    pressEnter: function () {
      if (e.keyCode === 13) {
        this.editCategory()
      }
    },
    onCancelEditCategory: function () {
      var vm = this
      vm.category = JSON.parse(vm.cached_category)
      vm.$emit('input', vm.category)
      vm.editText = false
    },
    onEditCategory: function () {
      var vm = this
      vm.editText = true
      vm.$nextTick(function () {
        if (vm.category && vm.editText) {
          vm.$refs.category.focus()
        }
      })
    },
    editCategory: function () {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        let data = {
          name: vm.category.name,
          id: vm.category.id,
          pageid: vm.selectedBot.pageid
        }
        vm.isLoading = true
        api.putsahapanrewardcategories(data, function (error, response) {
          vm.isLoading = false
          vm.editText = false
          vm.cached_category = JSON.stringify(vm.category)
          vm.$emit('input', vm.category)
          vm.$emit('close')
        })
      })
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      // console.log(newVal,this.$refs.tagInput.innerText)
      if (newVal != oldVal) {
        this.category = this.value
        this.cached_category = JSON.stringify(this.value)
        // this.$refs.tagInput.innerText = this.value.name
      }
      // this.text = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.move-vertical {
  border-right: 1px solid #eee;
  padding: 10px;
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/sahapan/ecommerce-category-edit.vue